<template>
    <div>
        <div class="modal fade" :class="showChangePassword?'show':''" id="historial_ingresos" tabindex="-1" aria-labelledby="myAccountJmLabel" aria-hidden="true"
            data-bs-backdrop="false" style="background-color:rgba(0, 0, 0, 0.5);">
            <div class="modal-dialog modal-lg">
                <div class="modal-content" style="background-color: rgba(60,60,60,.95);">
                    <div class="modal-header2 p-0" :style="skin.my_account.modal_header2">
                        <h6 class="modal-title" id="exampleModalLabel">Historial de Ingresos
                            <button id="closemyAccountJm" :style="skin.my_account.close_btn" @click="data_requested=false"
                                style="background:transparent;float: right;color:white" type="button" class="btn-close"
                                data-bs-dismiss="modal" aria-label="Close"><i class="fas fa-times"></i></button>
                        </h6>
                    </div>
                    <div class="modal-body p-4">
                        <div v-if="loading_report" style="width:100%" class="text-center p-2">
                            <div class="spinner-border" style="color:beige" role="status">
                                <span class="visually-hidden">Loading...</span>
                            </div>
                        </div>
                        <div class="table-responsive">
                            <table class="table" style="color:white;font-size: 15px;">
                                <thead>
                                    <tr>
                                        <th scope="col">Fecha</th>
                                        <th scope="col">Accion</th>
                                        <th scope="col">Direccion IP</th>
                                        <th scope="col">Dispositivo</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(item, index) in paginarArray(report, registers_per_page)[actual_page - 1]" :key="index">
                                        <td>{{ formatearFecha(item.fecha) }}</td>
                                        <td>{{ item.descripcion }}</td>
                                        <td>{{ item.ip }}</td>
                                        <td>
                                            <span v-if="item.plataforma == 'desktop'"><i class="fas fa-desktop" aria-hidden="true"></i></span>
                                            <span v-else><i class="fas fa-mobile-alt" aria-hidden="true"></i></span>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div>
                            <pagination class="float-end" :options="paginationConf" v-model="actual_page" :records="records" :per-page="registers_per_page" @paginate="paginate"/>
                        </div><br><br><br>
                        <div class="text-center">
                            <button @click="data_requested=false" class="btn" style="background-color: #292d3d;color:white" data-bs-dismiss="modal" aria-label="Close">Cerrar</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
  
<script>
import Pagination from 'vue-pagination-2';
import MyPagination from './Pagination.vue'
import axios from 'axios';
export default {
    name: "historialIngresos",
    props: ['skin', 'translation', 'language'],
    components:{Pagination},
    data() {
        return {
            report:[],
            actual_page:1,
            records:0,
            registers_per_page:10,
            paginationConf:{
                texts:{count:''},
                template:MyPagination
            },
            loading_report:false,
            data_requested:false
        }
    },
    computed: {
        user() {
            let data = this.$store.getters['getUserData'];
            return data;
        },
        showChangePassword(){
            if(this.$store.getters['getShowChangePassword']){
                document.getElementById('changePasswordBtn').click();
            }
            return this.$store.getters['getShowChangePassword'];
        },
        apiUrlnew(){
            return this.$store.getters['getApiUrlnew'];
        },
        site(){
            return this.$store.getters['getSite'];
        },
    },
    methods: {
        paginate(page){
            this.actual_page = page;
        },
        paginarArray(array, elementosPorPagina) {
            const paginas = [];
            let paginaActual = [];

            for (let i = 0; i < array.length; i++) {
                if (paginaActual.length === elementosPorPagina) {
                    paginas.push(paginaActual);
                    paginaActual = [];
                }
                paginaActual.push(array[i]);
            }

            if (paginaActual.length > 0) {
                paginas.push(paginaActual);
            }
            this.records = array.length;
            this.pages = paginas;
            return paginas;
        },
        async getData() {
            try {
                this.loading_report=true;
                this.data_requested=true;
                let data = await axios.get(this.apiUrlnew +"auditoria", {params:{
                    "login_Id": this.user.user_data.data.user_id ?? this.user.user_data.data.id,
                    "token":this.user.token
                }})
                this.report = data.data;
                this.loading_report=false;
            } catch (error) {
                this.loading_report=false;
            }
        },
        parseNumbers(number){
            return new Intl.NumberFormat("de-DE",{minimumFractionDigits:2, maximumFractionDigits: 2}).format(number)
        },  
        formatearFecha(fechaString) {
            const fecha = new Date(fechaString);
            const anio = fecha.getFullYear();
            const mes = this.agregarCeroDelante(fecha.getMonth() + 1);
            const dia = this.agregarCeroDelante(fecha.getDate());
            const Hora = this.agregarCeroDelante(fecha.getHours());
            const Minutos = this.agregarCeroDelante(fecha.getMinutes());
            const Segundos = this.agregarCeroDelante(fecha.getSeconds());
            return `${anio}/${mes}/${dia} ${Hora}:${Minutos}:${Segundos}`;
        },
        agregarCeroDelante(numero) {
            return numero < 10 ? '0' + numero : numero;
        },
    },
    mounted() {
        this.$root.$on('getIngresosHistory', () => {
            if(!this.data_requested){
                this.getData();
            }
        });
    }
}
</script>
  
<style scoped>
.modal-header2 {
    margin-left: 5% !important;
    margin-right: 5% !important;
    margin-top: -1.25rem !important;
    margin-bottom: 0 !important;
    height: 60px;
    padding: 1rem !important;
    color: #fff;
    border-bottom: none;
}
</style>